import React from "react";
import List from "../../shared/List";
import UserPopup from "../../shared/UserPopup";
import "../../style/BusinessDirectory.scss";
import Popup from "../../shared/Popup";
import helpers from "../../shared/helpers";
import config from "../../config";
import {userContext} from "../../userContext";
import {ajaxGET,ajaxPOST} from "../../ajax";

export default function BusinessDirectoryList({title,limit,filter}){

  const [showPopup,setShowPopup] = React.useState(false);
  const [row,setRow] = React.useState(false);
  const [actionLoading,setActionLoading] = React.useState(false);
  const [actionSuccess,setActionSuccess] = React.useState(false);
  const [userID,setUserID] = React.useState(false);
  const {user} = React.useContext(userContext);
  const [updateData,setUpdateData] = React.useState([]);
  const [focusBusiness,setFocusBusiness] = React.useState(false);




  const showOptions = (focusRow) => {
    setRow(focusRow);
    setShowPopup(true);
  };

  const hidePopup =()=>{
    setActionLoading(false);
    setActionSuccess(false);
    setShowPopup(false);
    setRow(false);
  }

  const rowAction = async (action,data,loading) => {
    setActionLoading(loading);
    var formData = new FormData;

    var result = await ajaxPOST(config.businessdirectory.API_DOMAIN+"api/directory/v2/"+action,data);

    setActionSuccess(result.message);
    if(action == "delete" || action == "approve"){
      setUpdateData({
        key:'id',
        keyValue:data.businessid,
        newData:"delete"
      });
    }
    else if(action == "unhide"){
      setUpdateData({
        key:'id',
        keyValue:data.commentid,
        newData:{hidden:false}
      });
    }
  };


  return (<div className="BusinessDirectory">
    <Popup
      show={focusBusiness}
      hide={()=>setFocusBusiness(false)}
    >
      <div className="details">
        {focusBusiness.image && (<img src={focusBusiness.image}/>)}
        <h2>{focusBusiness.title}</h2>
        {focusBusiness.address}
        <br/>{focusBusiness.email} &middot; {focusBusiness.phone}
        <p dangerouslySetInnerHTML={{__html:focusBusiness.description}}></p>
        {(focusBusiness.website && focusBusiness.website !== "http://") && (<p>Website: <a href={focusBusiness.website} target="_blank">{focusBusiness.website}</a></p>)}

        <div className="userBlock" onClick={()=>setUserID(focusBusiness.userid)}>
          <img src={focusBusiness.userpicture}/>
          <b>{focusBusiness.userfullname}</b>
          {focusBusiness.username}



        </div>
        <center>
          <button className="button2" onClick={()=>{ showOptions(focusBusiness); setFocusBusiness(false); rowAction("approve",{'businessid':focusBusiness.id},"Approving Business Listing"); }}>Approve</button>
          <button className="button2 red" onClick={()=>{ showOptions(focusBusiness); setFocusBusiness(false); rowAction("delete",{'businessid':focusBusiness.id},"Removing Business Listing")}}>Remove</button>
        </center>
      </div>

    </Popup>

    <Popup
     show={showPopup}
     hide={hidePopup}>
     {actionLoading ?
       (<>
         {actionSuccess ? (<>
           <center>{actionSuccess}</center>
           <ul className="optionsList">
            <li onClick={hidePopup}>OK</li>
           </ul>
         </>) : (<center>{actionLoading}</center>)}
       </>) : (
        <ul className="optionsList">
          <li onClick={()=>rowAction("approve",{'businessid':row.id},"Approving Business Listing")}>Approve Business Listing</li>
          <li onClick={()=>rowAction("delete",{'businessid':row.id},"Removing Business Listing")}>Remove Business Listing</li>
          <li onClick={hidePopup} className="cancel">Cancel</li>
         </ul>
       )}
    </Popup>
    <UserPopup id={userID} hide={()=>setUserID(false)}/>



    <List
      title={title}
      limit={limit}
      filter={filter}
      updateData={updateData}
      urlGET={`${config.businessdirectory.API_DOMAIN}api/directory/v2/list`}
      template={(i,index)=>{
        return (
          <tr key={`listing${index}`}>
            <td onClick={()=>setFocusBusiness(i)}>
              <b>{i.title}</b>

              <br/>{i.subregion.region.regionname} &middot; {i.category.categoryname}
            </td>
            <td style={{minWidth:"50px"}}>
              <div className="options" onClick={()=>showOptions(i)}>
                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Ellipsis Vertical Circle</title><circle fill="currentColor"  cx="256" cy="256" r="26"/><circle fill="currentColor" cx="256" cy="346" r="26"/><circle cx="256" cy="166" fill="currentColor"  r="26"/><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>
              </div>
            </td>
          </tr>
        )
      }}
    />

    <center>
      <button className="button2" onClick={()=>{ showOptions({businessid:"all"}); rowAction("populateCategories",{},"Updating Category List")}}>Populate Categories</button>
      <button className="button2" onClick={()=>{ showOptions({businessid:"all"}); rowAction("populateSearch",{},"Updating Search")}}>Populate Search</button>
    </center>
  </div>);
}
